export default __webpack_public_path__ + "static/Nezasa_1_1_de-d72c33d0fdbfb7e428e9ca607ec25ebf.jpg";